import type { ReactNode } from 'react';

import { cn } from '~/utils/cn';

interface PropsHeroCard {
  children: ReactNode;
  className?: string;
}

export default function HeroCard({ children, className }: PropsHeroCard) {
  return (
    <div
      className={cn(
        'relative overflow-hidden bg-gradient-to-br from-primary-01 via-primary-01 to-secondary-01',
        className,
      )}
    >
      <div className="absolute -right-16 -top-16 h-[180px] w-[180px] rounded-full bg-intense-01/10" />
      <div className="absolute -left-8 -bottom-12 h-[140px] w-[140px] rounded-full bg-intense-01/5" />
      <div className="relative">{children}</div>
    </div>
  );
}
